import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-hidden',
  templateUrl: './wallet-hidden.component.html',
  styleUrls: ['./wallet-hidden.component.scss']
})
export class WalletHiddenComponent {

}
